<template>
	<div>
		<table class="table table-bordered table-condensed table-siga" style="margin-top: 10px !important">
			<tbody>
				<tr>
					<td>
						<div class="row">
							<div class="col-xs-2 text-center" style="padding: 4px !important">
								<!-- <i style="font-size: 300px" class="fa icon-assinatura_eletronica_03"></i> -->
								<div class="no-print">
									<qrcode-vue :value="baseUrl" :size="size"></qrcode-vue>
								</div>

								<div class="print">
									<qrcode-vue :value="baseUrl" :size="sizePrint"></qrcode-vue>
								</div>
							</div>
							<div class="col-xs-10">
								<p style="margin-top: 4px !important; margin-bottom: 4px !important">
									A autenticidade do documento pode ser conferida no site: <br /><a :href="baseUrl" target="_blank">{{
										baseUrl
									}}</a>
									informando a chave de validação ou Leia o QR code ao lado.
								</p>
								<br />
								<p>Chave de validação: {{ chaveValidacao }}</p>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: {
		chaveValidacao: {
			required: false,
			type: String,
			default: ''
		}
	},

	data() {
		return {
			size: 100,
			sizePrint: 70
		}
	},

	computed: {
		baseUrl() {
			return $cliente.get('link_app') + '/#/valida-documento/' + this.chaveValidacao
		}
	}
}
</script>